module.exports = __webpack_public_path__ + "static/media/Statua_034.0c946d6f.jpg";